import { generateActions } from './utils'

const authDefinition = {
  login: ['form'],
  logout: ['goToHome'],
  refresh: ['isIframe'],
  register: ['form'],
  verify: ['token'],
  forgot: ['email'],
  resend: ['email'],
  reset: ['password', 'token'],
  change: ['form'],
  setNewUserInviteId: ['newUserInviteId'],
  impersonate: ['form'],
}

export const authActions = generateActions(['AUTH'], authDefinition)

export default authActions
